import { CustomModal } from '@/components/CustomModal';
import CampaignCreation from './CampaignCreation';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getLoggedInUser } from '@/store/account/selector';

interface CampaignCreationModalProps {
	isOpen?: boolean;
	onClose?: () => void;
	setShowCreateCampaign: React.Dispatch<React.SetStateAction<boolean>>;
	refetch: () => void;
	handleShowCampaign: (id: string) => void;
}

const CampaignCreationModal = ({
	isOpen,
	onClose,
	setShowCreateCampaign,
	refetch,
	handleShowCampaign,
}: CampaignCreationModalProps) => {
	const loggedInUser = useAppSelector(getLoggedInUser);

	const handleBack = () => {
		setShowCreateCampaign(false);
	};

	return (
		<CustomModal
			title="Create New Campaign"
			isModalOpen={isOpen}
			cancelAction={onClose}
			width={700}
			footer={null}
		>
			{isOpen && (
				<>
					<CampaignCreation
						setShowCreateCampaign={setShowCreateCampaign}
						refetch={refetch}
						campaign_user_email={loggedInUser.emailAddress ?? ''}
						campaign_user_name={loggedInUser.businessName ?? ''}
						handleBack={handleBack}
						modalView={true}
						clientType={'Client'}
						resellerView={false}
						userId={loggedInUser.id}
						handleShowCampaign={handleShowCampaign}
					/>
					<div className="help-section mb-5">
						<p>
							Need help? <a href="#">Contact our support team</a>
						</p>
					</div>
				</>
			)}
		</CustomModal>
	);
};

export default CampaignCreationModal;
